<template>
  <label class="mall-radio">
    <input type="radio" :name="name" :value="value" :disabled="disabled" v-model="inputValue" @change="changeHandler" v-bind="$attrs">
    <span class="label-text"><slot></slot></span>
  </label>
</template>

<script>
export default {
  name: 'MallRadio',

  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    checked: {
      type: [String, Number, Boolean, Array, Object],
      default: ''
    },
    value: {
      type: [String, Number, Object],
      default: ''
    },
    name: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: undefined
    }
  },

  data() {
    return {
      checkedProxy: false
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.checked;
      },
      set(val) {
        this.checkedProxy = val;
      }
    }
  },

  methods: {
    changeHandler() {
      this.$emit('change', this.checkedProxy);
    }
  }
}
</script>

<style lang="scss">
.mall-radio {
  display: inline-block;

  /**remove default style**/
  [type="radio"] {
    position: absolute;
    width: 0;
    height: 0;
    visibility: hidden;
  }

  [type="radio"] + .label-text {
    display: block;
    padding: 8px 11px;
    color: #121212;
    font-size: 14px;
    text-align: center;
    vertical-align: middle;
    background-color: #f8f8f8;
    border-radius: 20px;
    cursor: pointer;
    user-select: none;
  }

  /* Unchecked styles */
  [type="radio"]:not(:checked) + .label-text {
    color: #121212;
    background-color: #f8f8f8;
  }

  /* Checked styles */
  [type="radio"]:checked + .label-text {
    color: #ff5046;
    background: rgba(255, 80, 70, 0.10);
  }
}
</style>
